import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { config } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// TEMPORARILY DISABLED FOR DEBUGGING - Console logs enabled in all environments
// TODO: Re-enable after debugging is complete
// Only disable console in TRUE production (not staging/integration)
// Keep console.warn and console.error for critical issues even in production
/*
if (environment.production && config.envName === 'Production') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  // Keep console.warn and console.error for critical issues
}
*/


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    // Only log errors in development and not on iOS devices
    if (!environment.production &&
        !(window as any).webkit &&
        !navigator.userAgent.includes('iPhone') &&
        !navigator.userAgent.includes('iPad')) {
      console.log(err);
    }
  });
